// == USED IN SITE CONFIDENCE TESTS ==
export class IxAccountSwitcherTestIds {
  public static readonly NESTED_ACCOUNT_SWITCHER_TRIGGER = `ix-sw-nested-acc-trigger`;
}
